import type {
  ToolbarGroup as IToolbarGroup,
  ToolbarGroupOptions,
} from './types';

// Define a group of toolbar buttons that can appear as a dropdown list, or
// be expanded to buttons in the toolbar if there is enough space.
const ToolbarGroup = (props: ToolbarGroupOptions): IToolbarGroup => {
  return {
    type: 'group',
    ...props,
  };
};

export default ToolbarGroup;
